// import { AuthService } from '../services/storage.service'

export const PageMixin = {
  data () {
    return {
      paging: {
        page: 0,
        size: 5
      }
    }
  }
}

export const GlobalStateMixins = {
  data () {
    return {
      showModal: false,
      showLoading: false
    }
  },
  methods: {
    capitalize (text) {
      if (text) {
        const isSpklu = text.includes('SPKLU')
        const capi = text.replace(/_/g, ' ')
        if (isSpklu) {
          return 'SPKLU' + capi.split('SPKLU')[1].replace(/(^\w|\s\w)(\S*)/g, (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase())
        } else {
          return capi.replace(/(^\w|\s\w)(\S*)/g, (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase())
        }
      } else {
        return '-'
      }
    },

    replaceIfEmpty (text) {
      if (text === undefined || text === '' || text === null) {
        return '?'
      } else {
        return text
      }
    },

    dateIndo (paramDate) {
      const date = paramDate.substring(0, 10)
      const newFormat = date.split('-')
      return newFormat[2] + ' ' + this.getMonthName(parseInt(newFormat[1]) - 1).substring(0, 3) + ' ' + newFormat[0]
    },

    dateExportFormat () {
      const date = new Date()
      const yyyy = date.getFullYear()
      let mm = date.getMonth() + 1
      let dd = date.getDate()
      if (dd < 10) dd = '0' + dd
      if (mm < 10) mm = '0' + mm

      let hours = date.getHours()
      let minutes = date.getMinutes()
      let seconds = date.getSeconds()
      if (hours < 10) hours = '0' + hours
      if (minutes < 10) minutes = '0' + minutes
      if (seconds < 10) seconds = '0' + seconds
      return dd + '/' + mm + '/' + yyyy + ' ' + hours + ':' + minutes + ':' + seconds
    },

    MixinFormattedDate (date) {
      if (!date) return '-'
      const { day, month, year } = this.getDateDetail(date)
      const a = new Date(date)
      const hours = a.getHours()
      let minutes = a.getMinutes()
      // const seconds = a.getSeconds()
      // return `${day} ${this.getMonthName(month)} ${year} (${hours}:${minutes}:${seconds})`
      minutes = minutes.toString().length === 1 ? '0' + minutes : minutes
      return `${day} ${this.getMonthName(month)} ${year} (${hours}:${minutes})`
    },

    getMonthName (value) {
      const month = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
      return month[value]
    },

    getDateDetail (date) {
      const day = new Date(date).getDate()
      const month = new Date(date).getMonth()
      const year = new Date(date).getFullYear()
      return {
        day, month, year
      }
    },

    formatCurrency (value) {
      if (value != null) {
        const val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      } else if (value == null) {
        return '0'
      }
    },

    indoCurrencyFormat () {
      return new Intl.NumberFormat('id-ID', { minimumSignificantDigits: 1, style: 'currency', currency: 'IDR' })
    },

    secondToHoursAndMinutes (d) {
      if (!d) return '-'
      d = Number(d)
      var h = Math.floor(d / 3600)
      var m = Math.floor(d % 3600 / 60)
      var s = Math.floor(d % 3600 % 60)

      var hDisplay = h > 0 ? h + (h === 1 ? ' jam ' : ' jam ') : ''
      var mDisplay = m > 0 ? m + (m === 1 ? ' menit ' : ' menit ') : ''
      var sDisplay = s > 0 ? s + (s === 1 ? ' detik' : ' detik') : ''
      // return hDisplay + mDisplay + sDisplay

      if (h === 0 && m === 0) {
        return sDisplay
      } else {
        return hDisplay + mDisplay
      }
    },

    secondToMinutes (seconds) {
      var minutes = (seconds / 60)
      return minutes.toString().split('.')[0]
    },

    statusToEnum (statusStr) {
      const status = statusStr.toLowerCase()
      switch (status) {
        case 'available':
          return 1
        case 'in use':
          return 2
        case 'idle':
          return 3
        case 'unavailable':
          return 0
        case 'maintenance':
          return 4
      }
    },

    enumToStatus (en) {
      switch (en) {
        case 0:
          return 'Unavailable'
        case 1:
          return 'Available'
        case 2:
          return 'In Use'
        case 3:
          return 'Idle'
        case 4:
          return 'Maintenance'
        case 5:
          return 'SPKLU Non PLN'
      }
    },

    connectorClassByStatus (statusCode) {
      switch (statusCode) {
        case 0:
          return 'marker-detail-status-unavailable'
        case 1:
          return 'marker-detail-status-available'
        case 2:
          return 'marker-detail-status-inuse'
        case 3:
          return 'marker-detail-status-available'
        case 4:
          return 'marker-detail-status-unavailable'
      }
    },

    isMobileDevice () {
      return this.$vuetify.breakpoint.mobile && this.$vuetify.breakpoint.width < 600
    },

    // special search exact same match for treeview branch in user management
    findComplex (arr, id) {
      for (const item of arr) {
        const result = item.id === id ? item : find(item.children, id)
        if (result) return result
        for (const item2 of item.children) {
          const result2 = item2.id === id ? item2 : find(item2.children, id)
          if (result2) return result2
          for (const item3 of item2.children) {
            const result3 = item3.id === id ? item3 : find(item3.children, id)
            if (result3) return result3
            for (const item4 of item3.children) {
              const result4 = item4.id === id ? item4 : find(item4.children, id)
              if (result4) return result4
              for (const item5 of item4.children) {
                const result5 = item5.id === id ? item5 : find(item5.children, id)
                if (result5) return result5
              }
            }
          }
        }
      }
    },

    // special search exact same match for treeview branch in user management
    findComplexPerencanaan (arr, id) {
      for (const items of arr) {
        const result = items.id === id ? items : find(items.children, id)
        if (result) return result
        for (const items2 of items.children) {
          const result2 = items2.id === id ? items2 : find(items2.children, id)
          if (result2) return result2
        }
      }
    },

    // special search contain certain string for treeview branch
    containComplex (arr, search) {
      const keyword = search.toUpperCase()
      const newArray = []
      for (const item of arr) {
        const result = item.name.includes(keyword)
        if (result) newArray.push(item)
        for (const item2 of item.children) {
          const result2 = item2.name.includes(keyword)
          if (result2) newArray.push(item2)
          for (const item3 of item2.children) {
            const result3 = item3.name.includes(keyword)
            if (result3) newArray.push(item3)
            for (const item4 of item3.children) {
              const result4 = item4.name.includes(keyword)
              if (result4) newArray.push(item4)
              for (const item5 of item4.children) {
                const result5 = item5.name.includes(keyword)
                if (result5) newArray.push(item5)
              }
            }
          }
        }
      }

      return newArray
    },

    containComplexV2 (arr, search) {
      const keyword = search.toUpperCase()
      const newArray = []
      for (const item of arr) {
        const result = item.name.includes(keyword)
        if (result) newArray.push(item)
        for (const item2 of item.children) {
          const result2 = item2.name.includes(keyword)
          if (result2) newArray.push(item2)
        }
      }

      return newArray
    },

    // field input number
    numberOnly (evt) {
      const theEvent = evt || window.event
      let key = ''
      // Handle paste
      if (theEvent.type === 'paste') {
        key = event.clipboardData.getData('text/plain')
      } else {
      // Handle key press
        key = theEvent.keyCode || theEvent.which
        key = String.fromCharCode(key)
      }
      const regex = /[0-9]|\./
      if (!regex.test(key)) {
        theEvent.returnValue = false
        if (theEvent.preventDefault) theEvent.preventDefault()
      }
    }
  }
}
